import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import Section from "../../../components/ui/Section.jsx";
import InfoCard from "../../../components/ui/InfoCard.jsx";
import PrizeCarousel from "../../../components/ui/PrizeCarousel.jsx";
import { palette, shape, shadows } from "../../../theme/brand";

import { prizesList, corporateValuesList } from "../assets";

// Unlinked from `material-kit-pro-react` and redesigned: "Nuestros Logros" is now
// a carousel, and "Valores de la Empresa" is shown below as half-width panels.
const styles = {
  valuePanel: {
    backgroundColor: palette.surface,
    borderRadius: shape.borderRadius,
    boxShadow: shadows.card,
    padding: "28px 32px",
    height: "100%",
    boxSizing: "border-box"
  }
};

function SectionPills({ classes }) {
  return (
    <div>
      <Section title="Nuestros Logros">
        <PrizeCarousel prizes={prizesList} />
      </Section>

      <Section title="Valores de la Empresa">
        <Grid container spacing={32}>
          {corporateValuesList.map(value => (
            <Grid item xs={12} md={6} key={value.title}>
              <div className={classes.valuePanel}>
                <InfoCard
                  icon={value.icon}
                  title={value.title}
                  description={value.description}
                  iconColor="secondary"
                />
              </div>
            </Grid>
          ))}
        </Grid>
      </Section>
    </div>
  );
}

SectionPills.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SectionPills);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionPills.jsx